import { QueryClientProvider } from '@tanstack/react-query';
import { useMemo, type ReactNode } from 'react';
import { RouterProvider } from 'react-router';
import { Toaster } from 'sonner';

import { AuthProvider } from '../auth/AuthProvider';
import { createQueryClient } from '../lib/query-client';
import { createRouter } from './router';

/**
 * Provider order matters: `AuthProvider` needs the QueryClient (it clears the
 * cache when a session dies) and must sit ABOVE the router, so the guards see a
 * settled auth status on the very first render instead of flashing the login
 * screen at a signed-in user.
 */
export function App(): ReactNode {
  const queryClient = useMemo(() => createQueryClient(), []);
  const router = useMemo(() => createRouter(), []);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
        <Toaster
          position="bottom-right"
          richColors
          closeButton
          toastOptions={{ className: 'font-sans' }}
        />
      </AuthProvider>
    </QueryClientProvider>
  );
}
